/**
 * state-news.js  —  Kili AI Assistant · News Segment State Additions
 *
 * Merge the `newsState` object into your existing central `state` object in state.js.
 * Example in state.js:
 *
 *   import { newsState } from './state-news';
 *   export const state = {
 *     view: 'chat',
 *     ...existingFields,
 *     ...newsState,
 *   };
 *
 * Or spread it directly:
 *   Object.assign(state, newsState);
 */

export const newsState = {
  /* Currently displayed articles (after filter/search applied) */
  newsArticles: [],

  /* Raw unfiltered articles from last fetch */
  newsArticlesRaw: [],

  /* Active filter selections */
  newsFilters: {
    region:  'all',    // 'all' | 'kenya' | 'africa' | 'global'
    docType: 'all',    // 'all' | 'news' | 'press_release' | 'economic_report' | 'gazette'
    search:  '',       // free-text keyword filter (client-side)
  },

  /* Pagination */
  newsPage:    0,
  newsLimit:   20,
  newsTotal:   0,
  newsHasMore: false,

  /* Loading / error flags */
  newsLoading: false,
  newsError:   null,

  /* The article currently open in the inline preview drawer (null = closed) */
  newsPreviewArticle: null,

  /* Whether a breaking-news alert is pending (drives the pulse dot on the btn) */
  newsHasBreaking: false,

  /* Timestamp of last successful fetch (ms) — used to avoid spamming the API */
  newsLastFetched: 0,

  /* Polling interval reference — cleared on widget close */
  newsPollingTimer: null,
};

/** Resets pagination but keeps filters */
export function resetNewsPagination(state) {
  state.newsPage    = 0;
  state.newsHasMore = false;
  state.newsTotal   = 0;
  state.newsArticles    = [];
  state.newsArticlesRaw = [];
}

/** Applies client-side search + filter to raw articles, updates state.newsArticles */
export function applyNewsFilters(state) {
  const { region, docType, search } = state.newsFilters;
  const q = search.trim().toLowerCase();

  state.newsArticles = state.newsArticlesRaw.filter(a => {
    if (region  !== 'all' && a.region   !== region)  return false;
    if (docType !== 'all' && a.doc_type !== docType)  return false;
    if (q && !`${a.title} ${a.summary ?? ''} ${a.source_name ?? ''}`.toLowerCase().includes(q)) {
      return false;
    }
    return true;
  });
}
